import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./shared";

export default function FinalCTA() {
  return (
    <section id="contact" data-testid="cta-section" className="relative py-24 lg:py-36 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#2563EB] via-[#3B5BDB] to-[#6366F1]" />
      <motion.div
        animate={{ x: [0, 60, 0], y: [0, -40, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut" }}
        className="absolute -top-32 left-1/4 w-[30rem] h-[30rem] rounded-full bg-white/15 blur-[110px]"
      />
      <motion.div
        animate={{ x: [0, -50, 0], y: [0, 50, 0] }}
        transition={{ duration: 24, repeat: Infinity, ease: "easeInOut", delay: 3 }}
        className="absolute -bottom-40 right-1/5 w-[34rem] h-[34rem] rounded-full bg-[#00F0FF]/20 blur-[120px]"
      />
      <div
        className="absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
          backgroundSize: "72px 72px",
          maskImage: "radial-gradient(ellipse 70% 70% at 50% 50%, black, transparent)",
          WebkitMaskImage: "radial-gradient(ellipse 70% 70% at 50% 50%, black, transparent)",
        }}
      />

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 backdrop-blur px-4 py-1.5 text-xs font-semibold text-white mb-8">
            <Sparkles className="w-3.5 h-3.5" strokeWidth={2} />
            Early access now open
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-[-0.025em] leading-[1.06] text-white">
            Ready to Transform Your Orthodontic Practice?
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-base md:text-lg text-white/75 leading-relaxed mt-6 max-w-xl mx-auto">
            Join the next generation of orthodontic practices using AI to improve efficiency and patient care.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="flex flex-wrap justify-center gap-4 mt-10">
            <button
              type="button"
              data-testid="cta-book-demo-button"
              onClick={() => toast.success("Demo request received — our team will reach out shortly.")}
              className="group inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-[#2563EB] shadow-[0_20px_50px_rgba(0,0,0,0.25)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_26px_60px_rgba(0,0,0,0.3)] active:scale-[0.98]"
            >
              Book Demo
              <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
            </button>
            <button
              type="button"
              data-testid="cta-early-access-button"
              onClick={() => toast.success("You're on the early access list — welcome aboard.")}
              className="inline-flex items-center gap-2 rounded-full border border-white/35 bg-white/10 backdrop-blur px-8 py-4 text-sm font-semibold text-white transition-[background-color,transform,border-color] duration-300 hover:bg-white/20 hover:-translate-y-1 active:scale-[0.98]"
            >
              Request Early Access
            </button>
          </div>
        </Reveal>
        <Reveal delay={0.4}>
          <p className="text-xs text-white/50 mt-10">Free early access · Doctor-in-the-loop AI · Built for orthodontics</p>
        </Reveal>
      </div>
    </section>
  );
}
